import React from 'react';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';


import MoviesPage from "./pages/MoviesPage";
import MovieDetailsPage from "./pages/MovieDetailsPage";



export default (
    <Router>
        <div>
        <Switch>
            <Route path="/movies" component={MoviesPage}/>
            <Route path="/view/:id" component={MovieDetailsPage}/>
            <Route component={MoviesPage}/>
        </Switch>
        </div>
    </Router>
);



// WEBPACK FOOTER //
// ./js/movies/Routes.jsx